/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FolderIcon = createIcon("FolderIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.01 44c2.204 0 3.99-1.78 3.99-4V14a4 4 0 00-4-4H23.015c-1.113 0-2.162-.885-2.341-1.965l-.017-.1C20.294 5.762 18.226 4 16 4H3.999C1.791 4 0 5.796 0 7.982v32.036C0 42.218 1.805 44 3.99 44h34.02Z",
    fill: "#AA8226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.784 40.078C.351 42.244 1.804 44 3.99 44h34.022c2.203 0 4.337-1.743 4.773-3.922l4.432-22.156C47.649 15.756 46.196 14 44.01 14H9.989c-2.203 0-4.338 1.743-4.773 3.922L.784 40.078Z",
    fill: "#FFE385"
  }));
}, {
  "i18nKey": "svg.FolderIcon"
});